import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  boundariesSet,
  concatenateBoundariesByname
} from '../../../utilities/helpers';

import { organisationTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import saveAs from 'file-saver';
import moment from 'moment';

import {
  DOWNLOAD_HOME_INSIGHTS,
  DOWNLOAD_HOME_INSIGHTS_SUCCESS,
  DOWNLOAD_HOME_INSIGHTS_FAILURE,
} from '../../constants';


const downloadHomeInsights = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_HOME_INSIGHTS),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/report/${action.reportType}/download/${
          `${action.csvType}?`
        }${
          organisationTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'text',
        crossDomain: true,
      }).pipe(
        map(response => {
          const blob = new Blob(
            [
              `${response.response}`,
            ],
            { type: 'text/csv' }
          );

          const fileName = `LANDMARKSID_${action.reportType}_${action.fileName}${
            state$.value.insightsCriteria.insightType === 'organisation' &&
              state$.value.insightsCriteria.organisation.label
              ? `_${state$.value.insightsCriteria.organisation.label}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm0) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm0
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm1) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm1
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm2) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm2
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm3) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm3
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm4) === true
              ? `_${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm4
              )}`
              : ''
            }${
              boundariesSet(state$.value.insightsCriteria.poiId) === true
                ? `_${concatenateBoundariesByname(
                  state$.value.insightsCriteria.poiId
                )}`
                : ''
            }_${moment(new Date()).format("DD/MM/YYYY")}.csv`;

          saveAs(blob, fileName);
          return {
            type: DOWNLOAD_HOME_INSIGHTS_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: DOWNLOAD_HOME_INSIGHTS_FAILURE,
            error,
          })
        )
      )
    )
  );

export default downloadHomeInsights;
